var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-infographic-box", {
    staticClass: "rb-benefits-polarized-lenses",
    attrs: { "background-color": "light" },
    scopedSlots: _vm._u(
      [
        {
          key: "icon",
          fn: function () {
            return [_vm._t("icon")]
          },
          proxy: true,
        },
        {
          key: "title",
          fn: function () {
            return [_vm._t("title")]
          },
          proxy: true,
        },
        {
          key: "title_block",
          fn: function () {
            return [_vm._t("title_block")]
          },
          proxy: true,
        },
        {
          key: "excerpt",
          fn: function () {
            return [_vm._t("excerpt")]
          },
          proxy: true,
        },
        {
          key: "excerpt_block",
          fn: function () {
            return [_vm._t("excerpt_block")]
          },
          proxy: true,
        },
        {
          key: "cta_1",
          fn: function () {
            return [_vm._t("cta_1")]
          },
          proxy: true,
        },
        {
          key: "cta_2",
          fn: function () {
            return [_vm._t("cta_2")]
          },
          proxy: true,
        },
        {
          key: "cta_block",
          fn: function () {
            return [_vm._t("cta_block")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }